import { fetchOnce } from '@shared/hooks/http';
import { apiBase } from './api-base';

const get = (path) => fetchOnce(`${apiBase}${path}`, { credentials: 'include' });

const post = (path, body) =>
    fetchOnce(`${apiBase}${path}`, {
        method: 'POST',
        credentials: 'include',
        headers: body !== undefined ? { 'Content-Type': 'application/json' } : {},
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });

const put = (path, body) =>
    fetchOnce(`${apiBase}${path}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });

export const SarbSelfAssessmentService = {
    getAssessment: async (assessmentId) => {
        try {
            return await get(`/sarb-self-assessments/${assessmentId}`);
        } catch (error) {
            if (error.status === 404) return null;
            throw error;
        }
    },

    createAssessment: async (legalEntityAssessmentId) => {
        return await post('/sarb-self-assessments', { legalEntityAssessmentId });
    },

    updateResponse: async (responseId, rating, comments = '') => {
        return await put(`/sarb-self-assessments/responses/${responseId}`, { rating, comments });
    },

    autoPopulateFromEvidence: async (assessmentId) => {
        return await post(`/sarb-self-assessments/${assessmentId}/auto-populate`);
    },

    getPrincipleRatings: async (assessmentId) => {
        try {
            return await get(`/sarb-self-assessments/${assessmentId}/principles/ratings`);
        } catch {
            return [];
        }
    },

    // Which RDARR components roll up into each principle. Reference data - the same for every
    // assessment - fetched rather than hardcoded so the mapping lives only on the server.
    getPrincipleComponentMap: async () => {
        try {
            return await get('/sarb-self-assessments/principle-component-map');
        } catch {
            return [];
        }
    },

    getComponentRatings: async (assessmentId) => {
        try {
            return await get(`/sarb-self-assessments/${assessmentId}/components/ratings`);
        } catch {
            return [];
        }
    },

    getConsolidatedReport: async (periodId, legalEntityIds = null) => {
        const qs = new URLSearchParams({ periodId: periodId.toString() });
        if (legalEntityIds?.length) {
            legalEntityIds.forEach((id) => qs.append('legalEntityIds', id.toString()));
        }
        return await get(`/sarb-self-assessments/consolidated-report?${qs.toString()}`);
    },
};
